import React, { FC, useCallback, useEffect, useState } from 'react';
import Spinner from '@atlaskit/spinner';

import { RouteProps, useParams } from 'react-router-dom';
import { ApiAnexoSolicitacao } from 'service/api/solicitacao/ApiAnexoSolicitacao';
import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { Conteudo } from 'view/section/Conteudo/Conteudo';
import { MensagensErroServidor } from 'view/component/MensagensErroServidor/MensagensErroServidor';
import { ErrosUtils } from 'util/ErrosUtils';


interface QueryParams {
  idReino: any;
  idSolicitacao: any;
  idAnexo: any;
}

export const SolicitacaoAnexoPage: FC<RouteProps> = () => {
  const { idReino, idSolicitacao, idAnexo } = useParams<QueryParams>();
  const [url, setUrl] = useState<undefined|string>(undefined);
  const [erros, setErros] = useState<undefined|any>(undefined);

  const carregarUrl = useCallback(async () => {
    ApiAnexoSolicitacao.getEnderecoAnexo(idReino, idSolicitacao, idAnexo)
      .then(url => {
        setUrl(url);
        window.location.replace(url);
      })
      .catch(erros => setErros(ErrosUtils.converterErroAxiosParaErroSistema(erros)));
    
  }, [idReino, idSolicitacao, idAnexo])

  useEffect(() => {carregarUrl()}, [carregarUrl]);

  return (
    <>
    <Breadcrumb>
      <BreadcrumbItem href="/">Início</BreadcrumbItem>
      <BreadcrumbItem href="/solicitacoes">Solicitações</BreadcrumbItem>
      <BreadcrumbItem href={`/solicitacoes/${idSolicitacao}`}>Solicitação #{idSolicitacao}</BreadcrumbItem>
      <BreadcrumbItem href="">Acesso a anexo</BreadcrumbItem>
    </Breadcrumb>

    <Conteudo>
      <MensagensErroServidor erro={erros} />
      { !erros && <p>Acessando arquivo. Aguarde um pouco <Spinner /></p>}
      { url && <p><a href={url}>Caso o arquivo não tenha aberto ou o navegador não inicie o download, acesse o arquivo clicando aqui.</a></p> }
    </Conteudo>
   </>
  )
}


